import { render, staticRenderFns } from "./GsapRotateTranslate.vue?vue&type=template&id=753fb4b0&"
import script from "./GsapRotateTranslate.vue?vue&type=script&lang=js&"
export * from "./GsapRotateTranslate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports